import React from 'react';
import PropTypes from 'prop-types';

/**
 * The bottom links in all cards that have the bullets
 */
class ProductLinks extends React.Component {
	constructor(props) {
		super(props);
	}

	render() {
		let links = { ...this.props.products };

		return (
			<div className={'product-links'}>
				{Object.keys(links).map((key, item) =>
					<div key={key} className={(typeof links[key].url === 'undefined' ? ' d-none' : 'd-flex')}>
						<div className={'dark-bullet flex-shrink-0 mt-1 mr-2 mr-sm-0'}>
						</div>
						<a href={links[key].url} data-item={item}>
							{links[key].label}
						</a>
					</div>
				)}
			</div>
		);
	}
}

export default ProductLinks;

ProductLinks.propTypes = {
	products: PropTypes.object
};
